export default __webpack_public_path__ + "static/video-cf533197b873d8ebd14180ed2e498c09.mp4";